import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RespostaProcessamento } from '../mensagem-controle/resposta-processamento.model';
import { BaseService } from '../services/base-service.service';
import { ProcessoDocumento } from './processo-documento.model';
import { ConsultaPaginada, ConsultaPaginadaResultado } from 'maestro-ng';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class ProcessoDocumentoService extends BaseService<ProcessoDocumento, number> {
  constructor(http: HttpClient) {
    super('processoDocumento', http);
  }

  public recuperarPorProcessoId(processoId: number): Promise<ProcessoDocumento[]> {
    return firstValueFrom(this.http.get<ProcessoDocumento[]>(this.path(`recuperarPorProcessoId/${processoId}`)));
  }

  public recuperarTextoPorId(processoId: number, id: number): Promise<string> {
    return firstValueFrom(this.http.get(this.path(`recuperarTextoPorId/${processoId}/${id}`), { responseType: 'text' }));
  }

  public recuperarConteudoPorId(processoId: number, id: number): Promise<Blob> {
    return firstValueFrom(
      this.http.get(this.path(`recuperarConteudoPorId/${processoId}/${id}`), {
        headers: this.createJsonHttpHeaders(),
        responseType: 'blob',
      })
    );
  }

  public processarArquivoEstruturaPorOrigemId(fonteDados: string, origemId: number): Promise<RespostaProcessamento> {
    return firstValueFrom(
      this.http.post<RespostaProcessamento>(this.path(`processarArquivoEstruturaPorOrigemId/${fonteDados}/${origemId}`), {
        headers: this.createJsonHttpHeaders(),
      })
    );
  }

  public processarArquivoEstruturaPorId(processoId: number, id: number): Promise<RespostaProcessamento> {
    return firstValueFrom(
      this.http.post<RespostaProcessamento>(this.path(`processarArquivoEstruturaPorId/${processoId}/${id}`), {
        headers: this.createJsonHttpHeaders(),
      })
    );
  }

  public reprocessarArquivoEstruturaPorOrigemId(fonteDados: string, origemId: number): Promise<void> {
    return firstValueFrom(
      this.http.put<void>(this.path(`reprocessarArquivoEstruturaPorOrigemId/${fonteDados}/${origemId}`), {
        headers: this.createJsonHttpHeaders(),
      })
    );
  }

  public reprocessarArquivoEstruturaPorId(processoId: number, id: number): Promise<void> {
    return firstValueFrom(
      this.http.put<void>(this.path(`reprocessarArquivoEstruturaPorId/${processoId}/${id}`), {
        headers: this.createJsonHttpHeaders(),
      })
    );
  }
  public recuperarPaginadoPorProcesso(
    processoId: number,
    consulta: ConsultaPaginada
  ): Promise<ConsultaPaginadaResultado<ProcessoDocumento>> {
    return firstValueFrom(
      this.http.post<ConsultaPaginadaResultado<ProcessoDocumento>>(
        this.path(`recuperarPaginadoPorProcessoId/${processoId}`),
        consulta,
        { headers: this.createJsonHttpHeaders() }
      )
    );
  }
}
